import { render } from "./PublicReviews.vue?vue&type=template&id=0768e7d0"
import script from "./PublicReviews.vue?vue&type=script&lang=js"
export * from "./PublicReviews.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__